import React, { useEffect, useState } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import {
  StyledEngineProvider,
} from "@mui/material";

import {
  NavigationBar,
  ShowSelection,
} from "../../components";
import { GlobalContainer, MaxWidthContainer } from "./BookingManager/Steps/Session/SessionStep.styles";
import { PageContainer, SubtitleTypography, TitleContainer, TitleTypography } from "./AudienceShows.styles";
import { readShowsAudience } from "src/services/ShowV2Service";
import { Show } from "src/models/audience/Show";

interface AudienceShowsProps extends WithRouterProps {
}

const AudienceShows: React.FC<AudienceShowsProps> = ({
  router,
}) => {
  const [shows, setShows] = useState<Show[] | null>(null);

  const onShowCardClickHandler = (show: Show) => {
    router.push(`/audience/${show.publicRouteUrl}`)
  };

  useEffect(() => {
    readShows();
  }, []);

  const readShows = () => {
    readShowsAudience().then((showResponse) => {
      if (showResponse.data) {
        const availableShows = showResponse.data;
        setShows(availableShows);
      }
    });
  };

  return (
    <StyledEngineProvider injectFirst>
      <NavigationBar showHomeIconOnMobile={false} showMenu={true} />
      <GlobalContainer>
        <PageContainer>
          <MaxWidthContainer>
            <TitleContainer>
              <TitleTypography>Upcoming Shows</TitleTypography>
              <SubtitleTypography>
                You're in the right place!
                That's The Ticket is Australia's #1 Destination for tickets to be a part of the studio audience for Australia's biggest television shows!
                What's more, TICKETS ARE ALWAYS FREE!!
              </SubtitleTypography>
            </TitleContainer>
            <ShowSelection onShowCardClickHandler={onShowCardClickHandler} shows={shows}/>
          </MaxWidthContainer>
          </PageContainer>
        </GlobalContainer>
    </StyledEngineProvider>
  );
};

export default withRouter(AudienceShows);
